
export default [
    {
        path: "pos_stations",
        name: "posStations",
        meta: {
            authRequired: true,
            auth_roles: ["admin"],
        },
        component: () => import("../../views/Users/profile/posStationsTab/index.vue")
    }

]